import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { ArbolNodo, OpcionesArbol } from '../../model/arbol-decision.model';

@Injectable({
  providedIn: 'root'
})
export class ArbolDecisionApiService extends BaseApiService {

  getAncestrosOpcion(idOpcion: number): Observable<ArbolNodo[]> {
    return this.invocarSeguros<ArbolNodo[]>('GET', `arbol-decision/ancestros/${idOpcion}`);
  }

  getOpcionesArbol(idArbol?: number, idOpcion?: number): Observable<OpcionesArbol> {
    const params: string[] = [];
    if (idArbol != null) params.push(`idArbol=${idArbol}`);
    if (idOpcion != null) params.push(`idOpcion=${idOpcion}`);
    const query = params.length ? `?${params.join('&')}` : '';
    return this.invocarSeguros<OpcionesArbol>('GET', `arbol-decision/opciones${query}`);
  }
}
